
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

export interface SubscriptionStatus {
  subscribed: boolean;
  status?: string;
  plan_slug?: string;
  current_period_end?: string;
  cancel_at_period_end?: boolean;
  loading: boolean;
  error?: string;
}

export const useSubscription = () => {
  const { user } = useAuth();
  const [subscriptionStatus, setSubscriptionStatus] = useState<SubscriptionStatus>({
    subscribed: false,
    loading: false,
  });

  const checkSubscription = async () => {
    if (!user) {
      setSubscriptionStatus({ subscribed: false, loading: false });
      return;
    }

    setSubscriptionStatus(prev => ({ ...prev, loading: true, error: undefined }));

    try {
      const { data, error } = await supabase.functions.invoke('check-subscription');
      
      if (error) {
        console.error('Subscription check error:', error);
        setSubscriptionStatus({
          subscribed: false,
          loading: false,
          error: 'Erro ao verificar assinatura'
        });
        return;
      }

      setSubscriptionStatus({
        subscribed: data?.subscribed || false,
        status: data?.status,
        plan_slug: data?.plan_slug,
        current_period_end: data?.current_period_end,
        cancel_at_period_end: data?.cancel_at_period_end,
        loading: false,
      });
    } catch (error) {
      console.error('Subscription check exception:', error);
      setSubscriptionStatus({
        subscribed: false,
        loading: false,
        error: 'Erro inesperado ao verificar assinatura'
      });
    }
  };

  const openCustomerPortal = async () => {
    if (!user) {
      toast.error('Usuário não autenticado');
      return;
    }

    try {
      const { data, error } = await supabase.functions.invoke('customer-portal');
      
      if (error) {
        console.error('Customer portal error:', error);
        toast.error('Erro ao acessar portal de gerenciamento');
        return;
      }

      if (data?.url) {
        window.open(data.url, '_blank');
      } else {
        toast.error('URL do portal não recebida');
      }
    } catch (error) {
      console.error('Customer portal exception:', error);
      toast.error('Erro ao acessar portal de gerenciamento');
    }
  };

  useEffect(() => {
    if (user) {
      checkSubscription();
    }
  }, [user]);

  return {
    ...subscriptionStatus,
    checkSubscription,
    openCustomerPortal,
  };
};
